// src/components/BusinessRegSteps/Step3LocalizationOps.js
import React from 'react';
import { CurrencyDollarIcon, ClockIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const Step3LocalizationOps = ({ formData, updateFormData }) => {
    const currencies = [
        { value: 'ZAR', label: 'ZAR - South African Rand' },
        { value: 'USD', label: 'USD - United States Dollar' },
        { value: 'GBP', label: 'GBP - British Pound' },
        { value: 'EUR', label: 'EUR - Euro' },
        { value: 'AUD', label: 'AUD - Australian Dollar' },
        { value: 'CAD', label: 'CAD - Canadian Dollar' },
        { value: 'JPY', label: 'JPY - Japanese Yen' },
        // Add more currencies as needed
    ];

    // A simplified list of common timezones, in a real app, use a library like `moment-timezone` or `luxon`
    const timezones = [
        { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg (SAST)' },
        { value: 'America/New_York', label: 'America/New_York (EST/EDT)' },
        { value: 'Europe/London', label: 'Europe/London (GMT/BST)' },
        { value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)' },
        { value: 'Australia/Sydney', label: 'Australia/Sydney (AEST/AEDT)' },
        { value: 'Europe/Berlin', label: 'Europe/Berlin (CET/CEST)' },
        { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
        { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PST/PDT)' },
        // Add more timezones
    ];

    return (
        <fieldset className="border p-4 rounded-md space-y-4">
            <legend className="text-lg font-medium text-gray-900 flex items-center">
                <CurrencyDollarIcon className="h-6 w-6 text-indigo-500 mr-2" />
                Step 3: Localization & Operational Settings
            </legend>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Primary Operating Currency */}
                <div>
                    <label htmlFor="primary-currency" className="block text-sm font-medium text-gray-700">Primary Operating Currency</label>
                    <select
                        id="primary-currency"
                        name="primary-currency"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2 bg-white"
                        value={formData.primaryCurrency}
                        onChange={(e) => updateFormData('primaryCurrency', e.target.value)}
                    >
                        {currencies.map((curr) => (
                            <option key={curr.value} value={curr.value}>
                                {curr.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Timezone */}
                <div>
                    <label htmlFor="timezone" className="block text-sm font-medium text-gray-700">Timezone</label>
                    <select
                        id="timezone"
                        name="timezone"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2 bg-white"
                        value={formData.timezone}
                        onChange={(e) => updateFormData('timezone', e.target.value)}
                    >
                        {timezones.map((tz) => (
                            <option key={tz.value} value={tz.value}>
                                {tz.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Number of Locations */}
            <div>
                <label htmlFor="number-of-locations" className="block text-sm font-medium text-gray-700">Number of Business Locations</label>
                <select
                    id="number-of-locations"
                    name="number-of-locations"
                    required
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2 bg-white"
                    value={formData.numberOfLocations}
                    onChange={(e) => updateFormData('numberOfLocations', e.target.value)}
                >
                    <option value="1">1 (Single Location)</option>
                    <option value="2-5">2 - 5 Locations</option>
                    <option value="6-10">6 - 10 Locations</option>
                    <option value="11-50">11 - 50 Locations</option>
                    <option value="50+">50+ Locations</option>
                </select>
            </div>
        </fieldset>
    );
};

export default Step3LocalizationOps;